// VNEC P&L IFRS wrapper — loads pl-ifrs.html in iframe
export function renderPLIFRS() {
  return `<div style="width:100%;height:calc(100vh - 60px);margin:0;padding:0">
    <iframe src="/pl-ifrs.html" style="width:100%;height:100%;border:none;display:block"></iframe>
  </div>`;
}
window.__pageInit = null;
